import { isNonEmptyDigitString } from '@/utils/helper';

export const ADD_MULTIPLE_TRACKS_MIN = 1;
export const ADD_MULTIPLE_TRACKS_MAX = 100;

function isAddMultipleTracksQuantityInRange(quantity: number): boolean {
  return (
    Number.isInteger(quantity) &&
    quantity >= ADD_MULTIPLE_TRACKS_MIN &&
    quantity <= ADD_MULTIPLE_TRACKS_MAX
  );
}

export function parseAddMultipleTracksQuantity(value: string) {
  if (!isNonEmptyDigitString(value)) {
    return null;
  }

  const quantity = Number(value);
  return isAddMultipleTracksQuantityInRange(quantity) ? quantity : null;
}

export function normalizeAddMultipleTracksQuantityInput(
  value: string
): string | null {
  if (value === '') {
    return value;
  }

  if (!isNonEmptyDigitString(value)) {
    return null;
  }

  const quantity = Number(value);
  if (quantity < ADD_MULTIPLE_TRACKS_MIN) {
    return '';
  }

  if (quantity > ADD_MULTIPLE_TRACKS_MAX) {
    return ADD_MULTIPLE_TRACKS_MAX.toString();
  }

  return value;
}
